import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import I18n from 'PMT/i18n/I18n';

// -- routing
import Link from 'PMT/components/Link';
import {withRouter} from 'react-router-dom';

import SecurityContext from 'utils/permissions/SecurityContext';

// -- constants
import RoutingEnum from 'constants/RoutingEnum';

// -- stores
import { ProAccountStore, SessionStore } from 'stores';

// -- views
import AbstractMenuComponent from '../AbstractMenuComponent';
import ChooseRestaurantsGroupListMenu from './components/ChooseRestaurantsGroupListMenu';

/**
 * Handle the header view.
 * Responsive mode: display the same content as the sidebar
 */
class HeaderComponent extends AbstractMenuComponent {
  static propTypes = {
    onDisplayContactModal: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,

  };

  // -- events
  componentDidMount() {
    // hide the header navigation in mobile mode.
    // see https://github.com/react-bootstrap/react-bootstrap/issues/541
    // on no-mobile screen mode, ugly effect is made
    if (PMT.isMobileScreen()) {
      $('.nav a').on('click', function() {
        $('.navbar-toggle').click();
      });
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return true;
  }

  //
  // renderers
  //

  renderChooseRestaurantsGroupList() {
    return <ChooseRestaurantsGroupListMenu />;
  }

  renderSettings() {
    const proAccount = ProAccountStore.getMeAccount();

    let userName = '';
    if (!_.isNull(proAccount)) {
      userName = proAccount.getName();
    }

    return (
      <li className="dropdown" id="header">
        <a
          href="#"
          className="dropdown-toggle"
          data-toggle="dropdown"
          id="header-menu-dropdown"
        >
          <i className="fa fa-user" />
          &nbsp;
          {userName}
          &nbsp;
          <i className="fa fa-caret-down" />
        </a>

        <ul className="dropdown-menu dropdown-user">
          <li className="logout">
            <Link to={RoutingEnum.LOGOUT}>
              <i className="fa fa-close" />
              &nbsp;&nbsp;
              {I18n.tr('components.header.logout')}
            </Link>
          </li>
        </ul>
      </li>
    );
  }

  renderContact() {
    return (
      <li className="clear pointer">
        <a onClick={this.props.onDisplayContactModal}>
          <i className="fa fa-phone" />
          &nbsp;
          {I18n.tr('components.header.contact')}
        </a>
      </li>
    );
  }

  renderMenu() {
    const rows = [];

    rows.push(this.renderContact());

    let loggedInView = null;
    if (SessionStore.isLoggedIn()) {
      loggedInView = this.renderSettings();
    }

    return (
      <ul className="nav navbar-nav navbar-right">
        {this.renderOrder()}
        {this.renderPayment()}
        {this.renderRestaurantSettings()}

        {this.renderContact()}

        {SessionStore.isLoggedIn() && this.renderChooseRestaurantsGroupList()}
        {loggedInView}
        {this.renderLocales()}
      </ul>
    );
  }

  render() {
    return (
      <header className="js-header">
        <nav className="navbar navbar-fixed-top" role="navigation">
          <div className="container-fluid">
            <div className="navbar-header">
              <button
                type="button"
                className="navbar-toggle collapsed"
                data-toggle="collapse"
                data-target=".navbar-collapse"
                aria-expanded="false"
                aria-controls="#navbar"
              >
                <span className="sr-only">Toggle navigation</span>
                <span className="icon-bar" />
                <span className="icon-bar" />
                <span className="icon-bar" />
              </button>

              <div className="logo none">
                <Link to={RoutingEnum.DASHBOARD}>
                  <img src="/img/paymytable_logo.png" role="presentation" />
                </Link>
              </div>
            </div>

            <div id="navbar" className="navbar-collapse collapse">
              {this.renderMenu()}
            </div>
          </div>
        </nav>
      </header>
    );
  }
}

export default withRouter(HeaderComponent);
